{
  "name": "angular-client-base",
  "version": "2.5.4+163",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-with-browser": "ng serve -o --port 4305",
    "start-with-browser-ip": "ng serve -o --host 192.168.243.15 --port 4305",
    "startdebug": "ng serve",
    "startlocal": "ng serve -c testlocal",
    "buildcheck": "ng build -c buildCheck",
    "build": "ng build",
    "buildprod": "ng build -c production",
    "builddev": "ng build -c dev",
    "buildtest": "ng build -c test",
    "buildtesthelp": "ng build -c testhelp",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.7",
    "@angular/cdk": "^21.2.5",
    "@angular/common": "^21.2.7",
    "@angular/compiler": "^21.2.7",
    "@angular/core": "^21.2.7",
    "@angular/forms": "^21.2.7",
    "@angular/localize": "^21.2.7",
    "@angular/platform-browser": "^21.2.7",
    "@angular/platform-browser-dynamic": "^21.2.7",
    "@angular/router": "^21.2.7",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.2.0",
    "@fortawesome/free-solid-svg-icons": "^7.2.0",
    "@mapbox/mapbox-gl-draw": "^1.5.1",
    "@mapbox/mapbox-gl-draw-static-mode": "^1.0.1",
    "@mapbox/mapbox-gl-geocoder": "^5.1.2",
    "@mapbox/search-js-core": "^1.5.1",
    "@ng-idle/core": "^16.0.0",
    "@ng-idle/keepalive": "^16.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@syncfusion/ej2-angular-base": "32.2.3",
    "@syncfusion/ej2-angular-buttons": "32.2.7",
    "@syncfusion/ej2-angular-calendars": "32.2.7",
    "@syncfusion/ej2-angular-dropdowns": "32.2.7",
    "@syncfusion/ej2-angular-grids": "32.2.7",
    "@syncfusion/ej2-angular-inputs": "32.2.7",
    "@syncfusion/ej2-angular-layouts": "32.2.3",
    "@syncfusion/ej2-angular-navigations": "32.2.7",
    "@syncfusion/ej2-angular-notifications": "32.2.3",
    "@syncfusion/ej2-angular-popups": "32.2.7",
    "@syncfusion/ej2-angular-progressbar": "32.2.3",
    "@syncfusion/ej2-angular-splitbuttons": "32.2.7",
    "@syncfusion/ej2-base": "32.2.6",
    "@syncfusion/ej2-locale": "32.2.5",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.3",
    "@zxing/ngx-scanner": "21.0.0",
    "angularx-qrcode": "^21.0.5",
    "bootstrap": "^5.3.8",
    "cldr-data": "^36.0.5",
    "core-js": "^3.49.0",
    "luxon": "^3.7.2",
    "mapbox-gl": "^3.18.1",
    "ngx-lightbox": "^3.0.0",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.1.4",
    "@angular-eslint/builder": "^21.3.1",
    "@angular-eslint/eslint-plugin": "^21.3.1",
    "@angular-eslint/eslint-plugin-template": "^21.3.1",
    "@angular-eslint/schematics": "^21.3.1",
    "@angular-eslint/template-parser": "^21.3.1",
    "@angular/cli": "^21.1.4",
    "@angular/compiler-cli": "^21.2.7",
    "@angular/language-service": "^21.2.7",
    "@types/luxon": "^3.7.1",
    "@types/mapbox__mapbox-gl-draw": "^1.4.9",
    "@types/mapbox-gl": "^3.4.1",
    "@types/node": "^24.12.2",
    "@typescript-eslint/eslint-plugin": "^8.58.1",
    "@typescript-eslint/parser": "^8.58.1",
    "eslint": "^9.39.4",
    "jsdom": "^29.0.2",
    "ts-node": "^10.9.2",
    "typescript": "5.9.3",
    "vitest": "^4.1.3"
  }
}
